var _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSellButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_598_12573)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 18,
    r: 12,
    fill: "#FE4141"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1838 25.26C25.0438 25.26 27.0238 23.54 27.0238 20.94C27.0238 18.96 26.0438 17.9 23.0638 16.76C20.9638 15.94 20.2838 15.42 20.2838 14.5C20.2838 13.64 21.0438 12.98 22.0438 12.98C22.9838 12.98 23.8038 13.54 24.2838 14.58L26.3638 13.3C25.4838 11.62 24.0038 10.76 22.1238 10.76C19.5238 10.76 17.7838 12.3 17.7838 14.56C17.7838 16.58 18.8238 17.64 21.7438 18.78C23.8038 19.6 24.5238 20.2 24.5238 21.16C24.5238 22.34 23.6238 23.04 22.2238 23.04C20.6038 23.04 19.5038 22.1 19.3238 20.44L16.8438 21.06C17.2438 23.6 19.4038 25.26 22.1838 25.26Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_598_12573",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_598_12573"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_598_12573",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellButton);
export default __webpack_public_path__ + "static/media/SellButton.0e44e2bd8da7308f17c17d39f928bf46.svg";
export { ForwardRef as ReactComponent };